import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Badge } from "../Badge";
import { ButtonVariants, getButtonClassName } from "../Button";
import { ClassnamePassthruWrapper } from "~/components/ui/classname-passthru-wrapper";
import { Icon } from "../Icon";
import { IconTypes } from "../Icon/types";
import { Link } from "../Link";
import { LoadingSpinner } from "../LoadingSpinner";
import { faArrowRight } from "@fortawesome/pro-regular-svg-icons";

// // // //

export interface Props {
    label: string;
    description?: React.ReactNode;
    icon?: IconTypes;
    loading?: boolean;
    value?: string;
    children?: React.ReactNode;
    linkTo?: {
        label: string;
        href: string;
        analyticsLabel: string;
    };
}

export function SectionHeader(props: Props) {
    const {
        label,
        description = null,
        icon = null,
        loading = false,
        value = null,
        children,
        linkTo = null,
    } = props;

    const iconEl =
        icon === null ? null : (
            <Icon icon={icon} className="text-foreground h-5" />
        );

    const labelEl = (
        <ClassnamePassthruWrapper
            className={icon === null ? null : "flex items-center gap-2"}
        >
            {iconEl}
            <h2 className="text-2xl text-foreground">{label}</h2>
        </ClassnamePassthruWrapper>
    );

    return (
        <div className="flex items-start flex-col md:flex-row md:items-end justify-between mb-2">
            <div className="flex flex-col w-full">
                <div className="sm:flex sm:items-center select-none">
                    <div className="sm:flex-auto">
                        <div className="flex flex-col items-start md:flex-row md:justify-between md:items-center md:mb-0 mb-1">
                            {/* Render w/o Link */}
                            {linkTo == null && (
                                <div className="flex items-center gap-3">
                                    {labelEl}
                                    {loading && <LoadingSpinner size={5} />}
                                    {!loading && value && (
                                        <Badge label={value} variant="blue" />
                                    )}
                                </div>
                            )}

                            {/* Render w/ Link */}
                            {linkTo !== null && (
                                <div className="flex items-center gap-6">
                                    {labelEl}
                                    <Link
                                        href={linkTo.href}
                                        analyticsLabel=""
                                        className={getButtonClassName({
                                            variant: ButtonVariants.primaryLink,
                                            size: "md",
                                            className: "gap-2",
                                        })}
                                    >
                                        {linkTo.label}
                                        <FontAwesomeIcon
                                            icon={faArrowRight}
                                            className="h-4"
                                        />
                                    </Link>
                                </div>
                            )}

                            {/* ENHANCEMENT - simplify this so we only render this text once on the page */}
                            {description !== null && description !== "" && (
                                <p className="text-sm font-sans font-light leading-normal text-foreground/80 mb-2 md:hidden">
                                    {description}
                                </p>
                            )}

                            {children}
                        </div>

                        {description !== null && (
                            <p className="text-sm font-sans font-light leading-normal text-foreground/80 hidden md:block">
                                {description}
                            </p>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}
